<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 岗位管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>
                <el-select v-model="provinceValue" placeholder="请选择省份" class='handle-select mr10'>
                    <el-option
                        v-for="item in provinceOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="cityValue" placeholder="请选择市" class='handle-select mr10'>
                    <el-option
                        v-for="item in cityOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="areaValue" placeholder="请选择区" class='handle-select mr10'>
                    <el-option
                        v-for="item in areaOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model='enterpiseValue' placeholder='企业' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in enterpiseOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-select v-model='postValue' placeholder='岗位状态' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in postOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>

                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary' @click='addUser'>添加岗位</el-button>

            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label='岗位类型' align='center'>
                    <template slot-scope='scope'>{{ scope.row.typeName }}</template>
                </el-table-column>
                <el-table-column label='省市区' align='center'>
                    <template slot-scope='scope'>
                        {{ scope.row.provinceName + '|' + scope.row.cityName + scope.row.areaName }}
                    </template>
                </el-table-column>
                <el-table-column label='详细地址' align='center'>
                    <template slot-scope='scope'>{{ scope.row.addressDetails }}</template>
                </el-table-column>
                <el-table-column label='求职类型' align='center'>
                    <template slot-scope='scope'>{{ scope.row.postTypeName }}</template>
                </el-table-column>
                <el-table-column label='学历要求' align='center'>
                    <template slot-scope='scope'>{{ scope.row.educationRankName }}</template>
                </el-table-column>
                <el-table-column label='工作经验' align='center'>
                    <template slot-scope='scope'>{{ scope.row.workTimeName }}</template>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                </el-table-column>

<!--                <el-table-column label='招聘要求' align='center' width='300px' >-->
<!--                    <template slot-scope='scope'>{{ scope.row.descInfo }}</template>-->
<!--                </el-table-column>-->
                <el-table-column label='薪资待遇' align='center'>
                    <template slot-scope='scope'>{{ scope.row.salaryTypeName }}</template>
                </el-table-column>

                <el-table-column label='福利' align='center'>
                    <template slot-scope='scope'>{{ scope.row.welfareNames }}</template>
                </el-table-column>
                <el-table-column label='发布时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>
                </el-table-column>
                <el-table-column label='岗位状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.statusName }}</template>
                </el-table-column>
                <el-table-column label='是否置顶' align='center'>
                    <template slot-scope='scope'>
                        <el-tag
                            :type="scope.row.isTop===0?'danger':''"
                        >{{ scope.row.isTop === 0 ? '否' : '是' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>

                        <el-button
                            type='text'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            type='text'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            v-if='scope.row.status ==0'
                            type='text'
                            @click='handleApprove(scope.$index, scope.row)'
                        >审核
                        </el-button>
                        <el-button
                            v-if='scope.row.status ==1 || scope.row.status ==3  '
                            type='text'
                            @click='handleOpen(scope.$index, scope.row)'
                        >开放
                        </el-button>
                        <el-button
                            v-if='scope.row.status ==2'
                            type='text'
                            @click='handleClose(scope.$index, scope.row)'
                        >关闭
                        </el-button>

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <el-dialog title='添加岗位' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='岗位类型'>
                    <el-cascader
                        style='width: 100%;margin-right: 20px'
                        v-model='createForm.typeId'
                        :options='optionsValues'
                        @change='handleChange'></el-cascader>
                </el-form-item>
            </el-form>
            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择招聘企业'
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='createForm.postType' placeholder='请求职类型'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='全职' value='0'></el-option>
                        <el-option label='兼职' value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='学历要求'>
                    <el-select v-model='createForm.educationRank' placeholder='请选择学历要求'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='高中以下' value='0'></el-option>
                        <el-option label='高中' value='1'></el-option>
                        <el-option label='中专/技校' value='2'></el-option>
                        <el-option label='大专' value='3'></el-option>
                        <el-option label='本科' value='4'></el-option>
                        <el-option label='硕士' value='5'></el-option>
                        <el-option label='博士' value='6'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='工作经验要求'>
                    <el-select v-model='createForm.workTime' placeholder='请选择工作经验要求'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='无工作经验' value='0'></el-option>
                        <el-option label='一年以下' value='1'></el-option>
                        <el-option label='1到3年' value='2'></el-option>
                        <el-option label='3到5年' value='3'></el-option>
                        <el-option label='5到10年' value='4'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='薪资待遇'>
                    <el-select v-model='createForm.salaryType' placeholder='请选择薪资待遇'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='面议' value='0'></el-option>
                        <el-option label='1000以下' value='1'></el-option>
                        <el-option label='1000-2000' value='2'></el-option>
                        <el-option label='2000-3000' value='3'></el-option>
                        <el-option label='3000-5000' value='4'></el-option>
                        <el-option label='5000-8000' value='5'></el-option>
                        <el-option label='8000-15000' value='6'></el-option>
                        <el-option label='15000以上' value='7'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='福利'>
                    <el-select v-model='createForm.welfareId' multiple placeholder='请选择福利可多选'
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in postWelfareOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='招聘要求'>
                    <textarea v-model='createForm.descInfo' style='min-height: 200px;width: 100%'
                              placeholder='请输入招聘要求'></textarea>
                </el-form-item>
            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='编辑岗位' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='岗位类型'>
                    <el-cascader
                        style='width: 100%;margin-right: 20px'
                        v-model='createForm.typeId'
                        :options='optionsValues'
                        @change='handleChange'></el-cascader>
                </el-form-item>
            </el-form>
            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择招聘企业'
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='是否置顶'>
                    <el-switch
                        v-model="isTop"
                        active-color="#13ce66"
                        inactive-color="#cccccc">
                    </el-switch>
                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='createForm.postType' placeholder='请求职类型'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='全职' value='0'></el-option>
                        <el-option label='兼职' value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='学历要求'>
                    <el-select v-model='createForm.educationRank' placeholder='请选择学历要求'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='高中以下' value='0'></el-option>
                        <el-option label='高中' value='1'></el-option>
                        <el-option label='中专/技校' value='2'></el-option>
                        <el-option label='大专' value='3'></el-option>
                        <el-option label='本科' value='4'></el-option>
                        <el-option label='硕士' value='5'></el-option>
                        <el-option label='博士' value='6'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='工作经验要求'>
                    <el-select v-model='createForm.workTime' placeholder='请选择工作经验要求'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='无工作经验' value='0'></el-option>
                        <el-option label='一年以下' value='1'></el-option>
                        <el-option label='1到3年' value='2'></el-option>
                        <el-option label='3到5年' value='3'></el-option>
                        <el-option label='5到10年' value='4'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='薪资待遇'>
                    <el-select v-model='createForm.salaryType' placeholder='请选择薪资待遇'
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='面议' value='0'></el-option>
                        <el-option label='1000以下' value='1'></el-option>
                        <el-option label='1000-2000' value='2'></el-option>
                        <el-option label='2000-3000' value='3'></el-option>
                        <el-option label='3000-5000' value='4'></el-option>
                        <el-option label='5000-8000' value='5'></el-option>
                        <el-option label='8000-15000' value='6'></el-option>
                        <el-option label='15000以上' value='7'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='福利'>
                    <el-select v-model='createForm.welfareId' multiple placeholder='请选择福利可多选'
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in postWelfareOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='招聘要求'>
                    <textarea v-model='createForm.descInfo' style='min-height: 200px;width: 100%'
                              placeholder='请输入招聘要求'></textarea>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title='审批岗位' :visible.sync='approveVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='岗位类型' >
                    <el-cascader
                        disabled
                        style='width: 100%;margin-right: 20px'
                        v-model='createForm.typeId'
                        :options='optionsValues'
                        @change='handleChange'></el-cascader>
                </el-form-item>
            </el-form>
            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择招聘企业'
                               style='width: 100%;margin-right: 20px' disabled>
                        <el-option

                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='是否置顶'>
                    <el-switch
                        disabled
                        v-model="isTop"
                        active-color="#13ce66"
                        inactive-color="#cccccc">
                    </el-switch>
                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='createForm.postType' placeholder='请求职类型' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='全职' value='0'></el-option>
                        <el-option label='兼职' value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='学历要求'>
                    <el-select v-model='createForm.educationRank' placeholder='请选择学历要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='高中以下' value='0'></el-option>
                        <el-option label='高中' value='1'></el-option>
                        <el-option label='中专/技校' value='2'></el-option>
                        <el-option label='大专' value='3'></el-option>
                        <el-option label='本科' value='4'></el-option>
                        <el-option label='硕士' value='5'></el-option>
                        <el-option label='博士' value='6'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='工作经验要求'>
                    <el-select v-model='createForm.workTime' placeholder='请选择工作经验要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='无工作经验' value='0'></el-option>
                        <el-option label='一年以下' value='1'></el-option>
                        <el-option label='1到3年' value='2'></el-option>
                        <el-option label='3到5年' value='3'></el-option>
                        <el-option label='5到10年' value='4'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='薪资待遇'>
                    <el-select v-model='createForm.salaryType' placeholder='请选择薪资待遇' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='面议' value='0'></el-option>
                        <el-option label='1000以下' value='1'></el-option>
                        <el-option label='1000-2000' value='2'></el-option>
                        <el-option label='2000-3000' value='3'></el-option>
                        <el-option label='3000-5000' value='4'></el-option>
                        <el-option label='5000-8000' value='5'></el-option>
                        <el-option label='8000-15000' value='6'></el-option>
                        <el-option label='15000以上' value='7'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='福利'>
                    <el-select v-model='createForm.welfareId' multiple placeholder='请选择福利可多选' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in postWelfareOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='招聘要求'>
                    <textarea v-model='createForm.descInfo' style='min-height: 200px;width: 100%'
                              placeholder='请输入招聘要求' disabled></textarea>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                  <el-button @click='approveVisible=false'>取 消</el-button>
                <el-button @click='approveHttp(4)'>拒 绝</el-button>
                <el-button type='primary' @click='approveHttp(1)'>通 过</el-button>
            </span>
        </el-dialog>
        <el-dialog title='开放岗位' :visible.sync='isOpenVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='岗位类型' >
                    <el-cascader
                        disabled
                        style='width: 100%;margin-right: 20px'
                        v-model='createForm.typeId'
                        :options='optionsValues'
                        @change='handleChange'></el-cascader>
                </el-form-item>
            </el-form>
            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择招聘企业'
                               style='width: 100%;margin-right: 20px' disabled>
                        <el-option

                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='是否置顶'>
                    <el-switch
                        disabled
                        v-model="isTop"
                        active-color="#13ce66"
                        inactive-color="#cccccc">
                    </el-switch>
                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='createForm.postType' placeholder='请求职类型' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='全职' value='0'></el-option>
                        <el-option label='兼职' value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='学历要求'>
                    <el-select v-model='createForm.educationRank' placeholder='请选择学历要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='高中以下' value='0'></el-option>
                        <el-option label='高中' value='1'></el-option>
                        <el-option label='中专/技校' value='2'></el-option>
                        <el-option label='大专' value='3'></el-option>
                        <el-option label='本科' value='4'></el-option>
                        <el-option label='硕士' value='5'></el-option>
                        <el-option label='博士' value='6'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='工作经验要求'>
                    <el-select v-model='createForm.workTime' placeholder='请选择工作经验要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='无工作经验' value='0'></el-option>
                        <el-option label='一年以下' value='1'></el-option>
                        <el-option label='1到3年' value='2'></el-option>
                        <el-option label='3到5年' value='3'></el-option>
                        <el-option label='5到10年' value='4'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='薪资待遇'>
                    <el-select v-model='createForm.salaryType' placeholder='请选择薪资待遇' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='面议' value='0'></el-option>
                        <el-option label='1000以下' value='1'></el-option>
                        <el-option label='1000-2000' value='2'></el-option>
                        <el-option label='2000-3000' value='3'></el-option>
                        <el-option label='3000-5000' value='4'></el-option>
                        <el-option label='5000-8000' value='5'></el-option>
                        <el-option label='8000-15000' value='6'></el-option>
                        <el-option label='15000以上' value='7'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='福利'>
                    <el-select v-model='createForm.welfareId' multiple placeholder='请选择福利可多选' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in postWelfareOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='招聘要求'>
                    <textarea v-model='createForm.descInfo' style='min-height: 200px;width: 100%'
                              placeholder='请输入招聘要求' disabled></textarea>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                  <el-button @click='isOpenVisible=false'>取 消</el-button>
                <el-button type='primary' @click='approveHttp(2)'>开 放</el-button>
            </span>
        </el-dialog>
        <el-dialog title='关闭岗位' :visible.sync='isCloseVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='岗位类型' >
                    <el-cascader
                        disabled
                        style='width: 100%;margin-right: 20px'
                        v-model='createForm.typeId'
                        :options='optionsValues'
                        @change='handleChange'></el-cascader>
                </el-form-item>
            </el-form>
            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择招聘企业'
                               style='width: 100%;margin-right: 20px' disabled>
                        <el-option

                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='是否置顶'>
                    <el-switch
                        disabled
                        v-model="isTop"
                        active-color="#13ce66"
                        inactive-color="#cccccc">
                    </el-switch>
                </el-form-item>
                <el-form-item label='求职类型'>
                    <el-select v-model='createForm.postType' placeholder='请求职类型' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='全职' value='0'></el-option>
                        <el-option label='兼职' value='1'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='学历要求'>
                    <el-select v-model='createForm.educationRank' placeholder='请选择学历要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='高中以下' value='0'></el-option>
                        <el-option label='高中' value='1'></el-option>
                        <el-option label='中专/技校' value='2'></el-option>
                        <el-option label='大专' value='3'></el-option>
                        <el-option label='本科' value='4'></el-option>
                        <el-option label='硕士' value='5'></el-option>
                        <el-option label='博士' value='6'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='工作经验要求'>
                    <el-select v-model='createForm.workTime' placeholder='请选择工作经验要求' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='无工作经验' value='0'></el-option>
                        <el-option label='一年以下' value='1'></el-option>
                        <el-option label='1到3年' value='2'></el-option>
                        <el-option label='3到5年' value='3'></el-option>
                        <el-option label='5到10年' value='4'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='薪资待遇'>
                    <el-select v-model='createForm.salaryType' placeholder='请选择薪资待遇' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option label='面议' value='0'></el-option>
                        <el-option label='1000以下' value='1'></el-option>
                        <el-option label='1000-2000' value='2'></el-option>
                        <el-option label='2000-3000' value='3'></el-option>
                        <el-option label='3000-5000' value='4'></el-option>
                        <el-option label='5000-8000' value='5'></el-option>
                        <el-option label='8000-15000' value='6'></el-option>
                        <el-option label='15000以上' value='7'></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='福利'>
                    <el-select v-model='createForm.welfareId' multiple placeholder='请选择福利可多选' disabled
                               style='width: 100%;margin-right: 20px'>
                        <el-option
                            v-for='item in postWelfareOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='招聘要求'>
                    <textarea v-model='createForm.descInfo' style='min-height: 200px;width: 100%'
                              placeholder='请输入招聘要求' disabled></textarea>
                </el-form-item>


            </el-form>

            <span slot='footer' class='dialog-footer'>
                  <el-button @click='isCloseVisible=false'>取 消</el-button>
                <el-button type='primary' @click='approveHttp(3)'>关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue:"",
            areaOptions:[],
            areaValue:"",
            valueOptions: [],

            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            enterpiseOptions: [],
            enterpiseValue: '',
            postValue: '',
            postOptions: [{ 'value': '', 'label': '请选择岗位状态' },{ 'value': '0', 'label': '待审核' },{ 'value': '1', 'label': '待开放' }
                ,{ 'value': '2', 'label': '开放中' },{ 'value': '3', 'label': '已关闭' }],
            query: {
                pageIndex: 1,
                pageSize: 10,
                enterpriseId: ''
            },
            tableData: [],
            isTop:true,
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [{
                value: '0',
                label: '否'
            }, {
                value: '1',
                label: '是'
            }],
            value: '0',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            mealTableData: [],
            cardId: '',
            cardType: 0,
            editCardVisible: false,
            editCardLimitVisible: false,
            mealVisible: false,
            cardLimit: {},
            cardMealData: [],
            mealCountId: 0,
            mealCountVisible: false,
            mealCount: 0,
            optionsValues: [],
            postWelfareOptions: [],
            postWelfareValue: '',
            approveVisible:false,
            isOpenVisible:false,
            isCloseVisible:false

        };
    },
    created() {
        this.getData();
        this.getWorkType();
        this.getEnterpise();
        this.getPostWelfare();
        this.getProvince();

    },
    watch: {

        //监听内容
        provinceValue() {
            let that = this;
            this.areaValue=''
            this.cityValue=''
            let param = {"id":this.provinceValue}
            this.http.get('user/getCity', param).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = [{"id":"","name":"请选择市"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
            this.getEnterpise();
            console.log("provinceValue"+this.provinceValue)
        },
        cityValue(){
            this.getEnterpise();
            let that = this;
            this.areaValue=''
            let param = {"id":this.cityValue}
            this.http.get('user/getAreaById', param).then(res => {
                    if (res.code == 0) {
                        that.areaOptions =[{"id":"","name":"请选择区"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        areaValue(){
            this.getEnterpise();
            let that = this;

        }
    },
    methods: {
        getProvince(){
            let that = this;
            console.log(this.query.pageSize);
            let param = {}
            this.http.get('user/getProvince', param).then(res => {
                    if (res.code == 0) {



                        that.provinceOptions =[{"id":"","name":"请选择省份"},...res.data] ;
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });

        },
        getEnterpise() {
            let that = this;
            this.queryEnterprise.provinceId = this.provinceValue
            this.queryEnterprise.cityId = this.cityValue
            this.queryEnterprise.areaId = this.areaValue

            this.http.get('/qwpenterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptions=[]
                        that.enterpiseOptions.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },
        getPostWelfare() {
            let that = this;
            this.http.get('/post/getPostWelfare', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.postWelfareOptions = [];
                        res.data.forEach(res => {
                            that.postWelfareOptions.push({ 'value': res.id+"", 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },
        indexMethod(index) {
            return index + 1;
        },
        handleChange(value) {
            console.log(value);
        },

        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();
        }
        ,
        getWorkType() {
            let that = this;
            this.query.enterpriseId = this.enterpiseValue;
            this.http.get('/workType/getWorkTypeList', this.query).then(res => {
                    if (res.code == 0) {
                        that.optionsValues = res.data;
                    }
                },
                err => {

                });
        },
        getData() {
            let that = this;
            this.query.enterpriseId = this.enterpiseValue;
            this.query.provinceId = this.provinceValue
            this.query.cityId = this.cityValue
            this.query.areaId = this.areaValue
            this.query.status = this.postValue
            this.http.get('/post/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },

        delUserHttp(id) {
            let that = this;
            this.http.post('/post/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.addVisible = true;
            this.createForm = {};
        },

        addUserHttp() {
            let that = this;
            console.log(this.createForm);
            let strWelfareId = '';
            console.log(this.createForm.welfareId)
            for (const strWelfareIdKey in this.createForm.welfareId) {
                strWelfareId = strWelfareId + ',' + this.createForm.welfareId[strWelfareIdKey];
            }
            this.createForm.welfareId = strWelfareId;
            this.createForm.leaveTwoTypeId=this.createForm.typeId[1]
            this.createForm.leaveOneTypeId=this.createForm.typeId[0]
            this.createForm.typeId = this.createForm.typeId[2];


            this.http.post('/post/addPost', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }
        ,


        editHttp() {
            let that = this;
            let strWelfareId = '';
            if (this.isTop){
                this.createForm.isTop = '1'
            }else {
                this.createForm.isTop = '0'
            }
            console.log(this.createForm.welfareId)
            for (const strWelfareIdKey in this.createForm.welfareId) {
                strWelfareId = strWelfareId + ',' + this.createForm.welfareId[strWelfareIdKey];
            }
            this.createForm.welfareId = strWelfareId;
            this.createForm.leaveTwoTypeId=this.createForm.typeId[1]
            this.createForm.leaveOneTypeId=this.createForm.typeId[0]
            this.createForm.typeId = this.createForm.typeId[2];
            this.http.post('/post/updateById', this.createForm).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }

            });
        }
        ,

        approveHttp(status) {
            let that = this;
            let params = {};
            params.id =  this.createForm.id
            params.status = status
            this.http.post('/post/updateStatusById', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.approveVisible = false;
                    that.isOpenVisible=false
                    that.isCloseVisible=false

                    that.$message.success('提交成功');
                }

            });
        }
,
        handleEdit(index, row) {
            console.log('handleEdit'+row.isTop);
            this.idx = index;
            if (row.isTop == '0'){
                this.isTop=false;
            }else {
                this.isTop=true;
            }
            this.editVisible = true;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.workTime=this.createForm.workTime+''


            this.createForm.salaryType=this.createForm.salaryType+''
            this.createForm.educationRank=this.createForm.educationRank+''
            this.createForm.postType=this.createForm.postType+''
             let arrWelfareId = []
            this.createForm.welfareId.split(",").forEach( x=>{
                arrWelfareId.push(x)
            })
            let typeIds = [];
            typeIds[0]=this.createForm.leaveOneTypeId+""
            typeIds[1]=this.createForm.leaveTwoTypeId+""
            typeIds[2]=this.createForm.typeId+""
            this.createForm.typeId=typeIds
            this.createForm.welfareId=arrWelfareId
            console.log(this.createForm.welfareId)
        },
        handleClose(index, row){
            console.log('handleApprove'+row.isTop);
            this.idx = index;
            if (row.isTop == '0'){
                this.isTop=false;
            }else {
                this.isTop=true;
            }
            this.isCloseVisible = true;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.workTime=this.createForm.workTime+''


            this.createForm.salaryType=this.createForm.salaryType+''
            this.createForm.educationRank=this.createForm.educationRank+''
            this.createForm.postType=this.createForm.postType+''
            let arrWelfareId = []
            this.createForm.welfareId.split(",").forEach( x=>{
                arrWelfareId.push(x)
            })
            let typeIds = [];
            typeIds[0]=this.createForm.leaveOneTypeId+""
            typeIds[1]=this.createForm.leaveTwoTypeId+""
            typeIds[2]=this.createForm.typeId+""
            this.createForm.typeId=typeIds
            this.createForm.welfareId=arrWelfareId
            console.log(this.createForm.welfareId)
        },
        handleOpen(index, row){
            console.log('handleApprove'+row.isTop);
            this.idx = index;
            if (row.isTop == '0'){
                this.isTop=false;
            }else {
                this.isTop=true;
            }
            this.isOpenVisible = true;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.workTime=this.createForm.workTime+''


            this.createForm.salaryType=this.createForm.salaryType+''
            this.createForm.educationRank=this.createForm.educationRank+''
            this.createForm.postType=this.createForm.postType+''
            let arrWelfareId = []
            this.createForm.welfareId.split(",").forEach( x=>{
                arrWelfareId.push(x)
            })
            let typeIds = [];
            typeIds[0]=this.createForm.leaveOneTypeId+""
            typeIds[1]=this.createForm.leaveTwoTypeId+""
            typeIds[2]=this.createForm.typeId+""
            this.createForm.typeId=typeIds
            this.createForm.welfareId=arrWelfareId
            console.log(this.createForm.welfareId)
        },
        handleApprove(index, row) {
            console.log('handleApprove'+row.isTop);
            this.idx = index;
            if (row.isTop == '0'){
                this.isTop=false;
            }else {
                this.isTop=true;
            }
            this.approveVisible = true;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.workTime=this.createForm.workTime+''


            this.createForm.salaryType=this.createForm.salaryType+''
            this.createForm.educationRank=this.createForm.educationRank+''
            this.createForm.postType=this.createForm.postType+''
            let arrWelfareId = []
            this.createForm.welfareId.split(",").forEach( x=>{
                arrWelfareId.push(x)
            })
            let typeIds = [];
            typeIds[0]=this.createForm.leaveOneTypeId+""
            typeIds[1]=this.createForm.leaveTwoTypeId+""
            typeIds[2]=this.createForm.typeId+""
            this.createForm.typeId=typeIds
            this.createForm.welfareId=arrWelfareId
            console.log(this.createForm.welfareId)
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
